import { render } from "./GenericIncidentForm.vue?vue&type=template&id=0ea2e7b1"
import script from "./GenericIncidentForm.vue?vue&type=script&lang=js"
export * from "./GenericIncidentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__